import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AccountService } from './account.service';


@Injectable({ providedIn: 'root' })
export class ActiveRoleGuard implements CanActivate {
  constructor(private accountService: AccountService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    
    // Does not specify allowable active role, so return true (let it process to the route)
    const allowedActiveRole = route.data['allowedActiveRole'];
    if (!allowedActiveRole) {
      return true;
    }


    // Get the currently selected role
    var currentActiveRole = this.accountService.GetActiveRole();

    // We need a role to check against here since it requires a role (allowedRole != null). If we do
    // not have one to compare against, the user cannot go to the page.
    if (currentActiveRole == null || currentActiveRole != allowedActiveRole) {
      console.log(`Cannot to navigate to: ${state.url} with an active role of ${currentActiveRole}.`);
      return false;
    }

    return true;
  }
}
